// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListColumn-modulechatList__otcUA GretaAIChatChatList-modulechatList__P7L0S";
var _2 = "GretaAIChatChatListColumn-modulechatListColumn__I9SWh";
var _3 = "GretaAIChatChatListColumn-moduleresizeHandle__Xtqkp";
export { _1 as "chatList", _2 as "chatListColumn", _3 as "resizeHandle" }
